import { post } from '../index'

interface AnswerItem {
  questionHisId: string
  questionType: number
  answer: string | string[]
}
export interface AnswerList {
  examRefId: string
  paperHisRefId: string
  answerList: AnswerItem[]
}

export interface QuizQuery {
  relationType: number | string
  releaseId: number | string
  score?: number
  examRecordsId?: string
  courseType?: string
}

export const QUESTION_TYPES = {
  // 1单选题 2多选题 3填空题 4判断题 5问答题 6理解题
  single: 1,
  multi: 2,
  judge: 4
}

export async function getExamInfo (data: QuizQuery) {
  return await post('/certification/exam/getContent', data)
}

// 提交考试答案
export async function submitAnswer (data: AnswerList & QuizQuery) {
  return await post('/certification/exam/submitAnswer', data)
}

// 查询考试结果
export async function getExamResult (data: QuizQuery) {
  return await post('/certification/exam/getExamResult', data)
}

// 查询错题解析
export async function getExamAnalysis (data: {
  examRefId: string
  examRecordsId: string
}) {
  return await post('/certification/exam/getExamAnswerDetails', data)
}

// 查询考试资格
export async function getExamQualify (data: QuizQuery) {
  return await post('/certification/exam/entry', data)
}

// 实操考试-获取练习进度
export async function getExerciseResult (data: {
  releaseCourseId: number | string
  courseType: string
}) {
  return await post('/certification/skillLearn/getExerciseResult', data)
}

// 实操考试-获取考试id-生成一个随机的id
export async function generateExamId (data: { releaseCertificationId: number | string }) {
  return await post('/certification/skillLearn/getExamId', data)
}

// 实操考试-获取考试结果
export async function getSkillLearnExamResult (data: { releaseCertificationId: number | string }) {
  return await post('/certification/skillLearn/getExamResult', data)
}
